export const searchIconTestIds = {
    SEARCH_ICON_OPEN: 'SEARCH_ICON_OPEN',
    SEARCH_ICON_CLOSED: 'SEARCH_ICON_CLOSED',
};

export const queueColumnHeaderTestIds = {
    COLUMN_SORT_ASCENDING: 'COLUMN_SORT_ASCENDING',
    COLUMN_SORT_DESCENDING: 'COLUMN_SORT_DESCENDING',
};

export const queueRowTestIds = {
    QUEUE_ROWS: 'QUEUE_ROWS',
    QUEUE_GROUP_HEADER: 'QUEUE_GROUP_HEADER',
};
